<template>
  <tr class="customer-ortho-implant" :class="{ selected: is_selected }">
    <td class="customer-ortho-implant__active">
      {{ is_active }}
    </td>
    <td class="customer-ortho-implant__registration">
      {{ registration_date }}
    </td>
    <td class="customer-ortho-implant__attachment">
      {{ attachment_date }}
    </td>
    <td class="customer-ortho-implant__fail">
      {{ fail_date }}
    </td>
    <td class="customer-ortho-implant__tooth">
      {{ implant.tooth || '' }}
    </td>
    <td class="customer-ortho-implant__model">
      {{ implant.model }}
    </td>
    <td class="customer-ortho-implant__notes">
      {{ implant.notes }}
    </td>
    <td class="customer-ortho-implant__last-rev">
      {{ last_revision_date }}
    </td>
    <td class="customer-ortho-implant__next-rev">
      {{ implant.next_revision_months }}
    </td>
    <td class="customer-ortho-implant__actions">
      <button type="button" class="btn btn-wabident-round small" @click="$emit('edit', implant)">
        Editar
      </button>
      <button type="button" class="btn btn-wabident-round small red" @click="$emit('delete', implant)">
        <i class="fas fa-trash"></i>
      </button>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['implant', 'customer', 'selected_tooth'],
  data() {
    return {
    }
  },
  computed: {
    is_selected() {
      if (!this.selected_tooth || this.selected_tooth.length <= 0) {
        return false;
      }
      return this.selected_tooth.includes(this.implant.tooth);
    },
    is_active() {
      if (!this.implant.attachment_date) {
        return 'Pendiente';
      }

      if (this.implant.fail_date) {
        return 'Fallido';
      }

      return 'Activo';
    },
    registration_date() {
      if (this.implant.registration_date) {
        return window.WabiDent.fmtDate(this.implant.registration_date);
      }
      return '';
    },
    attachment_date() {
      if (this.implant.attachment_date) {
        return window.WabiDent.fmtDate(this.implant.attachment_date);
      }
      return '';
    },
    fail_date() {
      if (this.implant.fail_date) {
        return window.WabiDent.fmtDate(this.implant.fail_date);
      }
      return '';
    },
    last_revision_date() {
      if (this.implant.last_revision_date) {
        return window.WabiDent.fmtDate(this.implant.last_revision_date);
      }
      return '';
    },
  },
}
</script>

<style lang="scss">
.customer-ortho-implant__actions {
  display: flex;
  gap: 10px;
  justify-content: center;
  align-items: center;
}
</style>
